import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-remove-exclusion-dialog',
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [MatDialogModule, MatButtonModule, TranslateModule],
  template: `
    <h2 mat-dialog-title>{{ (data.removeAll ? 'REMOVE_ALL_EXCLUSIONS' : 'REMOVE_EXCLUSION') | translate }}</h2>
    <mat-dialog-content>
      {{ (data.removeAll ? 'REMOVE_ALL_EXCLUSIONS_CONFIRM' : 'REMOVE_EXCLUSION_CONFIRM') | translate : { name: data.deviceName || data.deviceId } }}
    </mat-dialog-content>
    <mat-dialog-actions class="ml-3 mb-3">
      <button class="btn btn-primary mr-2" (click)="confirm()">{{ 'CONFIRM' | translate }}</button>
      <button class="btn btn-outline-dark" (click)="cancel()">{{ 'CANCEL' | translate }}</button>
    </mat-dialog-actions>
  `
})
export class RemoveExclusionDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<RemoveExclusionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { deviceId?: string; deviceName?: string; removeAll?: boolean }
  ) {}

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
